import Immutable from 'immutable';
import { FILTER_PREFIX, FILTER_SEPARATOR } from '../../constants/FacetConstants';

export default function getToggledFilter(fieldId, currentFilter, activeFilters) {
  const queryField = `${FILTER_PREFIX}${fieldId}`;
  const filterValue = currentFilter.get('value');
  const activeValues = activeFilters.get(fieldId, Immutable.List()).map(f => f.get('value'));
  const newValues = activeValues.includes(filterValue) ? activeValues.filter(val => val !== filterValue) : activeValues.push(filterValue);

  return {
    [queryField]: (newValues.size > 0 ? newValues.join(FILTER_SEPARATOR) : undefined)
  };
}



// WEBPACK FOOTER //
// ./app/helpers/facets/getToggledFilter.js